import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BaseComponent } from '../../../core/abstractions/base.component';
import { AlertTypeModel } from '../../../models/alert-type.model';
import { AlertModel } from '../../../models/alert.model';
import { OptionalType } from '../../../models/types/optional.type';
import { AlertsResource } from '../../../services/resources/alerts.resource';
import { AlertEditDialogComponent } from './alert-edit-dialog/alert-edit-dialog.component';

@Component({
    selector: 'sl-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertsComponent extends BaseComponent implements OnInit {
    displayedColumns: string[] = ['alertType', 'customMessage', 'editBtn'];
    isLoading: boolean;
    alerts: AlertModel[] = [];
    alertTypes: AlertTypeModel[] = [];

    private readonly dialog = inject(MatDialog);
    private readonly alertsResource = inject(AlertsResource);

    ngOnInit(): void {
        this.refresh();
    }

    refresh(): void {
        this.isLoading = true;
        let isLoadingAlerts = true;
        let isLoadingAlertTypes = true;

        this.alertsResource.getAll().subscribe(result => {
            isLoadingAlerts = false;
            this.isLoading = isLoadingAlertTypes;
            this.alerts = result.value;
        });
        this.alertsResource.getAlertTypes().subscribe(result => {
            isLoadingAlertTypes = false;
            this.isLoading = isLoadingAlerts;
            this.alertTypes = result.value;
        });
    }

    openEditDialog(item: AlertModel): void {
        const ref = this.dialog.open(AlertEditDialogComponent, {
            disableClose: true,
            autoFocus: false,
            data: {
                alertId: item.id,
                isEditing: true
            },
            width: '500px',
            maxWidth: '98vw',
            maxHeight: '98svh'
        });
        ref.afterClosed().subscribe(() => {
            this.refresh();
        });
    }

    openCreateDialog(): void {
        const ref = this.dialog.open(AlertEditDialogComponent, {
            autoFocus: false,
            data: {
                editing: false
            },
            width: '500px',
            maxWidth: '98vw',
            maxHeight: '98svh'
        });
        ref.afterClosed().subscribe(() => {
            this.refresh();
        });
    }

    getAlertTypeDisplayName(className: string): OptionalType<string> {
        return this.alertTypes.find(t => t.className === className)?.displayName;
    }
}
